import { render, staticRenderFns } from "./TodoBoard.vue?vue&type=template&id=b8703fb6&scoped=true"
import script from "./TodoBoard.vue?vue&type=script&lang=js"
export * from "./TodoBoard.vue?vue&type=script&lang=js"
import style0 from "./TodoBoard.vue?vue&type=style&index=0&id=b8703fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8703fb6",
  null
  
)

export default component.exports